import { ShieldCheck } from "lucide-react";
import { useState } from "react";
import BONavigation from "../../../components/admin/BONavigation";
import { importAlimConfiance, AlimConfianceImportStats } from "../../../interfaces/establishments";

function today(): string {
    return new Date().toISOString().slice(0, 10);
}

export default function AlimConfianceImport() {
    const [date, setDate] = useState(today());
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState<AlimConfianceImportStats | null>(null);
    const [error, setError] = useState<string | null>(null);

    const handleImport = async () => {
        setLoading(true);
        setResult(null);
        setError(null);
        try {
            const stats = await importAlimConfiance(date);
            setResult(stats);
        } catch (err: any) {
            setError(err?.response?.data?.error || err?.message || "Erreur inconnue");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#F5F0EB]">
            <div className="mx-auto max-w-7xl px-6 py-6">
                <BONavigation />

                <div className="flex items-center gap-3 mb-6">
                    <ShieldCheck className="w-6 h-6 text-gray-900" />
                    <h1 className="text-xl font-semibold text-gray-900">Import AlimConfiance</h1>
                </div>

                <div className="border border-gray-200 rounded-lg p-6 max-w-md">
                    <p className="text-sm text-gray-600 mb-4">
                        Importe les inspections sanitaires de restaurants pour une date donnée depuis l'API AlimConfiance (DGAL).
                        Crée ou met à jour les établissements et génère les événements associés.
                    </p>

                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Date d'inspection
                        </label>
                        <input
                            type="date"
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                            className="border border-gray-200 rounded px-3 py-2 text-sm w-full focus:outline-none focus:border-gray-400"
                        />
                    </div>

                    <button
                        onClick={handleImport}
                        disabled={loading || !date}
                        className="bg-gray-900 text-white text-sm px-4 py-2 rounded hover:bg-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {loading ? "Import en cours…" : "Lancer l'import"}
                    </button>
                </div>

                {error && (
                    <div className="mt-4 border border-red-200 bg-red-50 rounded-lg px-4 py-3 text-sm text-red-700 max-w-md">
                        {error}
                    </div>
                )}

                {result && (
                    <div className="mt-6 max-w-md">
                        <h2 className="text-sm font-semibold text-gray-900 mb-3">Résultats — {date}</h2>
                        <div className="grid grid-cols-2 gap-3">
                            {[
                                { label: "Total inspections", value: result.total },
                                { label: "Établissements créés", value: result.created },
                                { label: "Établissements mis à jour", value: result.updated },
                                { label: "Ignorés (sans SIRET)", value: result.skipped },
                            ].map(({ label, value }) => (
                                <div key={label} className="border border-gray-200 rounded-lg p-4">
                                    <div className="text-2xl font-semibold text-gray-900">{value}</div>
                                    <div className="text-xs text-gray-500 mt-1">{label}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
